import React, { useEffect, useState } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection } from 'lexical';
import {
  INSERT_ORDERED_LIST_COMMAND,
  INSERT_UNORDERED_LIST_COMMAND,
  REMOVE_LIST_COMMAND,
  $isListNode,
} from '@lexical/list';
import { mergeRegister } from '@lexical/utils';

import { getSelectedNode } from '../../utils';
import { useSetting } from 'src/components/custom/Editor/hooks';

const FormatListBlock: React.FC = () => {
  const [editor] = useLexicalComposerContext();
  const [isUl, setIsUl] = useState<boolean>(false);
  const [isOl, setIsOl] = useState<boolean>(false);

  useEffect(() => {
    return mergeRegister(
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => {
          const selection = $getSelection();
          if (!$isRangeSelection(selection)) return;

          const node = getSelectedNode(selection);
          const nodeParent = node.getParent();

          if (!nodeParent) return;
          const anchorNode = selection.anchor.getNode();
          const element =
            anchorNode.getKey() === 'root'
              ? anchorNode
              : anchorNode.getTopLevelElementOrThrow();
          const elementKey = element.getKey();
          const elementDOM = editor.getElementByKey(elementKey);

          if (elementDOM !== null) {
            if ($isListNode(element)) {
              const tag = element.getTag();
              if (tag === 'ol') {
                setIsOl(true);
                setIsUl(false);
              }
              if (tag === 'ul') {
                setIsUl(true);
                setIsOl(false);
              }
            } else {
              setIsUl(false);
              setIsOl(false);
            }
          }
        });
      }),
    );
  }, [editor]);

  const { editable } = useSetting();

  return (
    <React.Fragment>
      <button
        onClick={() => {
          editor.dispatchCommand(
            isUl ? REMOVE_LIST_COMMAND : INSERT_UNORDERED_LIST_COMMAND,
            undefined,
          );
        }}
        className={'toolbar-item spaced ' + (isUl ? 'active' : '')}
        aria-label="Format List Un Order"
        disabled={!editable}
      >
        <i className="format list_unorder" />
      </button>
      <button
        onClick={() => {
          editor.dispatchCommand(
            isOl ? REMOVE_LIST_COMMAND : INSERT_ORDERED_LIST_COMMAND,
            undefined,
          );
        }}
        className={'toolbar-item spaced ' + (isOl ? 'active' : '')}
        aria-label="Format List Order"
        disabled={!editable}
      >
        <i className="format list_order" />
      </button>
    </React.Fragment>
  );
};

export default FormatListBlock;
